import { serializeObject, hasQueryParams, getIsJSON } from '../common/util';

const setOption = (options = {}) => {
    const { method, url, params, body } = options;
    let newOptions = {...options};

    const lowerMethod = method?.toLowerCase() || 'get';
    
    if(lowerMethod === 'get' && params) {
        newOptions.url = `${url}${!hasQueryParams(url) ? '?' : ''}${params ? serializeObject(params) : ''}`;
        delete newOptions.params;
    }

    if(body && !getIsJSON(body)) {
        newOptions.body = JSON.stringify(body);
    }

    return newOptions;
};

export const getFetchData = (options = {}) => {
    if(!options?.url) {
        console.error('호출할 api url이 존재하지 않습니다.');
        return;
    }

    const option = setOption(options);
    const url = option.url;

    return fetch(url, option)
    .then(res => res?.json());
};